import { render, staticRenderFns } from "./payment_receipt_temp1.vue?vue&type=template&id=08e84846&scoped=true"
import script from "./payment_receipt_temp1.vue?vue&type=script&lang=js"
export * from "./payment_receipt_temp1.vue?vue&type=script&lang=js"
import style0 from "./payment_receipt_temp1.vue?vue&type=style&index=0&id=08e84846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e84846",
  null
  
)

export default component.exports